import styled from 'styled-components';

import FullBooked from '@/components/atom/icon/FullBooked';
import { BookingScheduleStatus } from '@/types/doctor';

interface Props {
  bookingScheduleStatus: BookingScheduleStatus;
}
const DiagnosisEmptySlot = ({ bookingScheduleStatus }: Props) => {
  switch (bookingScheduleStatus) {
    case BookingScheduleStatus.FullyBooked:
      return (
        <Wrapper>
          <FullBooked />
          <Contents>
            예약이 꽉 찼어요<span>다른 날짜를 선택해주세요</span>
          </Contents>
        </Wrapper>
      );
    case BookingScheduleStatus.Holiday:
      return (
        <Wrapper>
          <FullBooked />
          <Contents>
            비대면 진료 쉬는 날이에요
            <span>다른 날짜를 선택해주세요.</span>
          </Contents>
        </Wrapper>
      );
    default:
      return null;
  }
};

export default DiagnosisEmptySlot;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 20px 0;
  gap: 20px;
  align-items: center;
`;

const Contents = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  ${({ theme }) => `
    ${theme.typography.UI18SB};
    color: ${theme.color.gray700};

    span {
      margin-top: 4px;
      ${theme.typography.UI15R};
      color: ${theme.color.gray400};
    }
  `};
`;
